import messages from './password-input-lang.json';
export default {
	data() {
		return {
			inputType: 'password'
		};
	},
	props: {
		value: {
			required: true
		},
		fieldError: {
			required: true
		},
		inputId: {
			required: true
		}
	},
	i18n: { messages },
	methods: {
		send(e) {
			this.$emit('input', e.target.value);
		},
		focusInput() {
			this.$nextTick(() => {
				this.$refs['password-input'].focus();
			});
		},
		showIt() {
			this.inputType = 'text';
			this.focusInput();
		},
		hideIt() {
			this.inputType = 'password';
			this.focusInput();
		}
	}
};
